import { ModuleBase, Link, ResponsiveImage, Button } from '@/components';
import Instagram from '@/assets/instagram2.svg';
import Facebook from '@/assets/facebook2.svg';
import TikTok from '@/assets/tiktok.svg';
import Twitter from '@/assets/twitter2.svg';
import Linkedin from '@/assets/linkedin.svg';
import Youtube from '@/assets/youtube.svg';
import { isColorDark, themeFromBg } from '@/utils';
import { motion } from 'framer-motion';
import FadeUpAnimation from '@/components/animations/FadeUpAnimation/FadeUpAnimation';
import FadeUpStarter from '@/components/animations/FadeUpAnimation/FadeUpStarter';

import { transition } from '@/components/animations/FadeUpAnimation/transition';

const SocialMediaGallery = ({ data }) => {
  // console.log(isColorDark, 'isColorDark');
  const isDark = isColorDark(data.backgroundColour);

  return (
    <ModuleBase data={data}>
      <FadeUpStarter>
        <div className="container color-from-bg ">
          <div className="text-wrapper lg:flex lg:justify-between">
            <div className="title-wrapper lg:max-w-[426px]">
              <FadeUpAnimation>
                <p className="color-from-bg text-large-paragraph">{data.label}</p>
              </FadeUpAnimation>
              <FadeUpAnimation>
                <p className="leading-32 text-title-s color-from-bg  font-ivy-ora mt-2 mb-[17px]">{data.heading}</p>
              </FadeUpAnimation>
            </div>
            <div className="description-wrapper lg:max-w-[431px]">
              <FadeUpAnimation>
                <p className="color-from-bg text-large-paragraph mb-6">{data.description}</p>
              </FadeUpAnimation>
              <FadeUpAnimation>
                <div className="social-icons-wrapper flex ">
                  {data?.socialLinks?.map((socialItem, socialIndex) => (
                    <div className="social-link-item mr-4 md:mr-4 last:mr-0  flex items-center" key={socialIndex}>
                      {socialItem.socialPlatform.toLowerCase() === 'twitter' ? (
                        <Link link={socialItem.link}>
                          <Twitter role="presentation" className={`${isDark ? '[&_path]:fill-white' : ''}`} />
                        </Link>
                      ) : socialItem.socialPlatform.toLowerCase() === 'tiktok' ? (
                        <Link link={socialItem.link}>
                          <TikTok role="presentation" className={`${isDark ? '[&_path]:fill-white' : ''}`} />
                        </Link>
                      ) : socialItem.socialPlatform.toLowerCase() === 'instagram' ? (
                        <Link link={socialItem.link}>
                          <Instagram role="presentation" className={`${isDark ? '[&_path]:fill-white' : ''}`} />
                        </Link>
                      ) : socialItem.socialPlatform.toLowerCase() === 'facebook' ? (
                        <Link link={socialItem.link}>
                          <Facebook role="presentation" className={`${isDark ? '[&_path]:fill-white' : ''}`} />
                        </Link>
                      ) : socialItem.socialPlatform.toLowerCase() === 'linkedin' ? (
                        <Link link={socialItem.link}>
                          <Linkedin
                            role="presentation"
                            className={`${isDark ? '[&_path]:fill-white' : '[&_path]:!fill-[#081B36]'}`}
                          />
                        </Link>
                      ) : socialItem.socialPlatform.toLowerCase() === 'youtube' ? (
                        <Link link={socialItem.link}>
                          <Youtube
                            role="presentation"
                            className={`${isDark ? '[&_path]:fill-white' : '[&_path]:!fill-[#081B36]'}`}
                          />
                        </Link>
                      ) : null}
                    </div>
                  ))}
                </div>
              </FadeUpAnimation>
            </div>
          </div>

          <FadeUpAnimation>
            <div className="image-wrapper grid lg:grid-cols-4 grid-cols-2 gap-2 md:gap-6 lg:gap-4 mt-10 lg:mt-[59px]">
              {data.images.map((image, index) => (
                <div key={index} className={`relative w-full h-full aspect-square`}>
                  <ResponsiveImage
                    image={image}
                    widths={{ xs: 308, sm: 308, md: 308, lg: 800, xl: 800, xxl: 800 }}
                    heights={{ xs: 308, sm: 308, md: 308, lg: 800, xl: 800, xxl: 800 }}
                    showImageCredit
                  />
                </div>
              ))}
            </div>
          </FadeUpAnimation>

          {data.primaryCTA && (
            <motion.div
              variants={{ inactive: { opacity: 0 }, active: { opacity: 1, transition: { ...transition, delay: 1 } } }}
              className="my-10 lg:mt-[58px] lg:mb-[112px] mx-auto block w-fit"
            >
              <Button link={data.primaryCTA} type="primary" theme={themeFromBg(isColorDark(data.backgroundColour))} />
            </motion.div>
          )}
        </div>
      </FadeUpStarter>
    </ModuleBase>
  );
};

export default SocialMediaGallery;
